export enum Stage {
  LEARNING = "learningStage",
}
